/**
 * This simple type specifies the possible modes for canvas.
 */
export enum CanvasMode {
    /** With this mode you can drag type instances onto canvas placeholders */
    DRAG_TYPE_INSTANCE = "DRAG_TYPE_INSTANCE",

    /** With this mode you can draw preset page objects on canvas */
    DRAW = "DRAW",

    /** With this mode you can edit control points for curve. */
    EDIT_CURVE = "EDIT_CURVE",

    /** Editing a shape in pen mode */
    EDIT_PEN = "EDIT_PEN",

    /** With this mode you can crop picture */
    EDIT_PICTURE = "EDIT_PICTURE",

    /** With this mode you can edit text. */
    EDIT_TEXT = "EDIT_TEXT",

    /** With this mode you are turning off DRAW mode. */
    NODRAW = "NODRAW",

    /** With this mode you can select page objects. */
    SELECT = "SELECT",
}
